import ShimmerLoader from '@components/ShimmerLoader/ShimmerLoader';

import styles from './CardLoader.module.scss';

interface LoaderProps {
  appearance: 'fit' | 'standalone';
}
const Loader: React.FC<React.PropsWithChildren<LoaderProps>> = ({ appearance, children, ...props }) => {
  return (
    <div className={styles['card-loader']} data-appearance={appearance}>
      <div className={styles['card-loader-header']} {...props}></div>
      {children}
      <div className={styles['card-loader-details-section']}>
        <div className={styles['card-loader-long-section']} {...props}></div>
        <div className={styles['card-loader-med-section']} {...props}></div>
        <div className={styles['card-loader-med-section']} {...props}></div>
      </div>

      <div className={styles['card-loader-field-container']}>
        <div className={styles['card-loader-field-icon']} {...props}></div>
        <div className={styles['card-loader-field-details']}>
          <div className={styles['card-loader-med-section']} {...props}></div>
        </div>
      </div>
    </div>
  );
};
export const CardLoader: React.FC<React.PropsWithChildren<LoaderProps>> = ({ appearance, children }) => {
  return (
    <ShimmerLoader>
      {(props) => (
        <Loader appearance={appearance} {...props}>
          {children}
        </Loader>
      )}
    </ShimmerLoader>
  );
};
